export const MESSAGE_CONTENT_TYPES = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  FILE: 'FILE',
  LOCATION: 'LOCATION',
  BUTTON: 'BUTTON',
  LIST: 'LIST',
  TEMPLATE: 'TEMPLATE',
};

const contentTypeBuilders = {
  TEXT: (data) => ({
    type: 'TEXT',
    text: data.text,
  }),
  IMAGE: (data) => ({
    type: 'IMAGE',
    media: {
      link: data.link || data.url,
      caption: data.caption || '',
    },
  }),
  VIDEO: (data) => ({
    type: 'VIDEO',
    media: {
      link: data.link || data.url,
      caption: data.caption || '',
    },
  }),
  AUDIO: (data) => ({
    type: 'AUDIO',
    media: {
      link: data.link || data.url,
    },
  }),
  DOCUMENT: (data) => ({
    type: 'DOCUMENT',
    media: {
      link: data.link || data.url,
      filename: data.filename || '',
      caption: data.caption || '',
    },
  }),
  FILE: (data) => ({
    type: 'FILE',
    media: {
      link: data.link || data.url,
      filename: data.filename || '',
    },
  }),
  LOCATION: (data) => ({
    type: 'LOCATION',
    latitude: data.latitude,
    longitude: data.longitude,
    name: data.name || '',
  }),
  BUTTON: (data) => ({
    type: 'BUTTON',
    text: data.text,
    buttons: data.buttons || [],
  }),
  LIST: (data) => ({
    type: 'LIST',
    text: data.text,
    buttons: data.buttons || [],
    sections: data.sections || [],
  }),
  TEMPLATE: (data) => ({
    type: 'TEMPLATE',
    ...(data.template ? { template: data.template } : {}),
    ...(data.templateName ? { templateName: data.templateName } : {}),
    ...(data.parameters ? { parameters: data.parameters } : {}),
  }),
};

export const buildMessageContent = (contentType, contentData) => {
  const builder = contentTypeBuilders[contentType];

  if (!builder) {
    throw new Error(
      `Unsupported content type: ${contentType}. Supported types: ${Object.keys(contentTypeBuilders).join(', ')}`
    );
  }

  return builder(contentData);
};
